import { formatISO, subYears } from 'date-fns';

import type { TrackReleaseType } from '~/modules/artist-roster/pages/artist-details/utils/types';

export function formatReleaseDate(releaseType?: TrackReleaseType): {
  startDate?: string;
  endDate?: string;
} {
  switch (releaseType) {
    case 'recent':
      return {
        startDate: formatISO(subYears(Date.now(), 3), {
          representation: 'date',
        }),
        endDate: undefined,
      };
    case 'shallow':
      return {
        startDate: formatISO(subYears(Date.now(), 10), {
          representation: 'date',
        }),
        endDate: formatISO(subYears(Date.now(), 3), { representation: 'date' }),
      };
    case 'deep':
      return {
        startDate: undefined,
        endDate: formatISO(subYears(Date.now(), 10), {
          representation: 'date',
        }),
      };
    case undefined:
    default:
      return {
        startDate: undefined,
        endDate: undefined,
      };
  }
}
